import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawSummary(doc, summary,grandTotal,) {
 // doc.setFontSize(14);
  //doc.setFont("helvetica", "bold");
 // doc.text("CALCULATION SUMMARY ", 14, 20);
  autoTable(doc, {
    startY: 35,
    ...PDF_TABLE_STYLE,

    head: [["Description", "Amount"]],

    body: [
      ["Total Labour on Cost (Distributed OC Labour)", format(grandTotal.oncostlabour)],
      ["Total Store on Cost (Distributed OC Store)", format(grandTotal.oncoststore)],
       ["", ""],
      ["Grand Total Labour Cost" ,format(grandTotal.highlyskilledcost+grandTotal.skilledcost+grandTotal.semiskilledcost+grandTotal.unskilledcost)],
      
      
    ],

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_SUMMERY_HEADING,
      cellPadding: 3,
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_SUMMERY_HEADING,
      textColor: PDFCOLORSHEME.FONT_COLOR_SUMMERY_HEADING,
      fontStyle: "bold",
      halign: "center",
    },

    columnStyles: {
      0: {
        halign: "left",
        cellWidth: 120,
      },
      1: {
        halign: "right",
        cellWidth: 60,
      },
    },

    // didParseCell(data) {
    //   // Blank separator row
    //   if (data.row.index === 5) {
    //     data.cell.styles.fillColor = [245, 245, 245];
    //   }

    //   // Highlight Direct Store & Returned Store
    //   if (data.row.index >= 6) {
    //     data.cell.styles.fontStyle = "bold";
    //     data.cell.styles.fillColor = [240, 240, 240];
    //   }
    // },
  });
}

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}